import React, { useState, useCallback } from 'react'
import styled from 'styled-components'
import { CircularProgress } from '@mui/material'

import { ColourButton, Text, Spacer, icons } from 'portal/lib/primitives'
import { sizes } from '@qflow/theme'

interface ReportEventCellProps {
  item: {
    readSASUrl?: string
    reportName?: string
  }
  noDownload?: boolean
}

export function ReportEventCell({
  item,
  noDownload = false
}: ReportEventCellProps) {
  const [downloading, setDownloading] = useState(false)

  const handleDownload = useCallback(() => {
    if (item.readSASUrl && !noDownload) {
      setDownloading(true)
      window.open(item.readSASUrl, '_blank')
      // Reset downloading state after a short delay
      setTimeout(() => setDownloading(false), 1000)
    }
  }, [item.readSASUrl, noDownload])

  return (
    <>
      {!noDownload && item.readSASUrl && (
        <ColourButton.Trigger
          style={{ margin: '0', display: 'inline-flex' }}
          onClick={handleDownload}
          disabled={downloading}
        >
          {downloading ? (
            <CircularProgress
              size={sizes.LARGER}
              thickness={5}
              color={'inherit'}
            />
          ) : (
            <icons.Download />
          )}

          <Spacer.Fine />

          <StatusText>Download</StatusText>
        </ColourButton.Trigger>
      )}
    </>
  )
}

const StatusText = styled(Text)`
  color: inherit;
  min-width: 4rem;
  display: inline-block;
`
